export const bonStatus = [
    { label: 'Nouveaux', value: 'DRAFT' },
    { label: 'En attente des signatures', value: 'CREATED' },
    { label: 'Signature manquante', value: 'PENDING' },
    { label: 'Rejetés', value: 'REFUSED' },
    { label: 'Signés', value: 'SIGNED' },
    { label: 'Facturés', value: 'INVOICING' },
]